















import Vue from "vue"
import MaterialIcon, {
  OUTLINED,
} from "~/components/guideline/icon/MaterialIcon.vue"

export default Vue.extend({
  components: {
    MaterialIcon,
  },
  props: {
    // お気に入りされているかどうかを示すフラグ
    isFavorited: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    iconType() {
      return {
        OUTLINED,
      }
    },
  },
  methods: {
    onClick(e: any) {
      this.$emit("click", e)
    },
  },
})
